import React, { useContext, useEffect, Fragment, useReducer, useState } from 'react';
import { Link } from 'react-router-dom';
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import { Row, Card, Col, Alert, Button } from "react-bootstrap";
import { reducer } from '../bootstrap/alertReducer';
import { Sparklines, SparklinesLine } from "react-sparklines";
import { useOktaAuth } from '@okta/okta-react';
import DualArea from "../charts/Chartjs/dualArea";

import DefaultCard, { BgCard, SocialCard } from '../Widget/DefaultCard';

import NewStudent from "../Widget/WidgetBasic/NewStudent";
import TotalCourse from "../Widget/WidgetBasic/TotalCourse";
import FeeCollection from "../Widget/WidgetBasic/FeeCollection";

//Import Components
import { ThemeContext } from "../../../context/ThemeContext";
import PaymentTable from './Elements/PaymentTable';
import TopProducts from './Elements/TopProducts';
import ActivityTab from './Elements/ActivityTab';
import UserActivity from './Elements/UserActivity';
import TotalStudent from '../Widget/WidgetBasic/TotalStudent';


// import { Link } from 'react-router-dom';




import {
    Table,
    Badge,
    Dropdown,
    ProgressBar,
} from "react-bootstrap";


const ApexLine4 = loadable(() => pMinDelay(import("../charts/apexcharts/Line4"), 1000));
const ApexTreeNode = loadable(() => pMinDelay(import("../charts/apexcharts/ApexTreeNode"), 1000));
const ApexHeatMap = loadable(() => pMinDelay(import("../charts/apexcharts/ApexHeatMap"), 1000));

const AreaChart2Canvas = loadable(() =>
    pMinDelay(import("./Elements/AreaChart2Canvas"), 1000)
);
const ChartWidget2 = loadable(() =>
    pMinDelay(import("./Elements/ChartWidget2"), 1000)
);
const ShareProfitCanvas2 = loadable(() =>
    pMinDelay(import("./Elements/ShareProfitCanvas2"), 1000)
);
const ActiveUserCanvas = loadable(() =>
    pMinDelay(import("./Elements/ActiveUserCanvas"), 1000)
);

const fullBatterySvgIcon = (<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" className="svg-main-icon">
    <g stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
        <rect x="0" y="0" width="44" height="44"></rect>
        <rect fill="#33CA93" x="2" y="7" width="17" height="10" rx="2"></rect>
        <path d="M20,10 L21,10 C21.5522847,10 22,10.4477153 22,11 L22,13 C22,13.5522847 21.5522847,14 21,14 L20,14 L20,10 Z" fill="#000000" opacity="0.3"></path>
    </g>
</svg>
)
const sampleData = [6, 2, 8, 4, 3, 8, 4, 3, 6, 5, 9, 2,];

const TtitleCode = (props) => {
    return (
        <div className={`card-header border-0 ${props.design}`}>
            <h3 className="card-title text-white">{props.title}</h3>
            <h5 className="text-white mb-0">
                <i className="fa fa-caret-up" /> {props.number}
            </h5>
        </div>
    )
}


const bgCarddBlog = [
    { title: "Team One", number: '3180', icon: <i className="la la-users" />, percent: '80%', color: "success" },
    { title: "Team Two", number: '360', icon: <i className="la la-users" />, percent: '90%', color: "success" },
    { title: "Team Three", number: '28', icon: <i className="la la-users" />, percent: '60%', color: "warning" },
    { title: "Team Four", number: '390', icon: <i className="la la-users" />, percent: '15%', color: "danger" },
];
const Home = () => {
    const {
        changeBackground,
        changeSideBarStyle,
        chnageSidebarColor,
        changeNavigationHader
    } = useContext(ThemeContext);



    useEffect(() => {
        changeBackground({ value: "light", label: "Light" });
        changeSideBarStyle({ value: "mini", label: "Mini" });
        chnageSidebarColor("color_3");
        changeNavigationHader("color_3");

    }, []);
    return (
        <>
            <AllSection />
        </>
    )
}



function AllSection() {
    const initial = true;
    const [state, dispatch] = useReducer(reducer, initial);

    return (

        <div className="row">
            <div className="row">
                <div className="col-lg-12">
                    <Card className="mb-4">
                        <Card.Header>
                            <Card.Title style={{ fontSize: '1.5rem' }}>
                                Data Lineage
                            </Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <ApexTreeNode />
                        </Card.Body>
                    </Card>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12">
                    <Card className="mb-4">
                        <Card.Header>
                            <Card.Title style={{ fontSize: '1.5rem' }}>
                                Heat Map
                            </Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <ApexHeatMap />
                        </Card.Body>
                    </Card>
                </div>
            </div>


            <div className="row">
                <div className="col-xl-12 col-xxl-12 col-lg-6 col-sm-6">
                    {/* <Alert variant="warning" dismissible show={state.iconbigwarning} className="left-icon-big">
                            <button className="btn-close" onClick={() => dispatch({ type: 'iconbigwarning' })}><span><i className="mdi mdi-close" /></span></button>
                            <div className='media'>
                                <div variant="" className="alert-left-icon-big">
                                    <span>
                                        <i className="mdi mdi-help-circle-outline"></i>
                                    </span>
                                </div>
                                <div className="media-body">
                                    <h6 className="mt-1 mb-2">Pending Right To Be Forgotten Tasks!</h6>
                                    <p className="mb-0">You have 2 pending RTBF Approvals</p>
                                </div>
                            </div>
                        </Alert> */}
                    {/* <div className="card overflow-hidden">
                            <div className="card-body pb-0 px-4 pt-4">
                                <div className="row">
                                    <div className="col">
                                        <h5 className="mb-1">2000</h5>
                                        <span className="text-success">Total Reports</span>
                                    </div>
                                </div>
                            </div>
                            <div className="chart-wrapper">									
                                <AreaChart2Canvas />
                            </div>
                        </div> */}
                </div>
                {/* <div className="col-xl-3 col-xxl-3 col-lg-6 col-sm-6">
                        <div className="card bg-success	overflow-hidden">
                            <div className="card-body pb-0 px-4 pt-4">
                                <div className="row">
                                    <div className="col">
                                        <h5 className="text-white mb-1">1999</h5>
                                        <span className="text-white">Healthy Data Reports</span>
                                    </div>
                                </div>
                            </div>
                            <div className="chart-wrapper" style={{ width: "100%" }}>
                                <Sparklines data={sampleData}>
                                    <SparklinesLine color="#39f4bc"
                                        style={{ stroke: "#20dea6", strokeWidth: 1, fill: "#fff" }}
                                    />
                                </Sparklines>
                            </div>
                        </div>
                    </div> */}
                {/* <div className="col-xl-3 col-xxl-3 col-lg-6 col-sm-6">
                        <div className="card bg-primary overflow-hidden">
                            <div className="card-body pb-0 px-4 pt-4">
                                <div className="row">
                                    <div className="col text-white">
                                        <h5 className="text-white mb-1">570</h5>
                                        <span>VIEWS OF YOUR PROJECT</span>
                                    </div>
                                </div>
                            </div>
                            <div className="chart-wrapper px-2">
                                <ChartWidget2 />
                            </div>
                        </div>
                    </div> */}
                {/* <div className="col-xl-3 col-xxl-3 col-lg-6 col-sm-6">
                        <div className="card overflow-hidden">
                            <div className="card-body px-4 py-4">
                                <h5 className="mb-3">1700 / <small className="text-primary">Sales Status</small></h5>
                                <div className="chart-point">
                                    <div className="check-point-area">
                                        <ShareProfitCanvas2 />
                                    </div>
                                    <ul className="chart-point-list">
                                        <li><i className="fa fa-circle text-primary me-1" /> 40% Tickets</li>
                                        <li><i className="fa fa-circle text-success me-1" /> 35% Events</li>
                                        <li><i className="fa fa-circle text-warning me-1" /> 25% Other</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div> */}
                {/* <div className="col-xl-4 col-xxl-4 col-lg-12 col-md-12">
                        <div className="card">
                            <div className="card-header border-0 pb-0">
                                <h4 className="card-title">Timeline</h4>
                            </div>
                            <div className="card-body p-0">
                                <div id="DZ_W_TimeLine1" className="widget-timeline dz-scroll style-1 px-4 ms-2 py-2 my-4" style={{ height: "250px" }}>
                                    <ul className="timeline">
                                        <li>
                                            <div className="timeline-badge primary"></div>
                                            <Link to={"#"} className="timeline-panel text-muted" >
                                                <span>10 minutes ago</span>
                                                <h6 className="mb-0">Youtube, a video-sharing website <strong className="text-primary">$500</strong>.</h6>
                                            </Link>
                                        </li>
                                        <li>
                                            <div className="timeline-badge info">
                                            </div>
                                            <Link to={"#"} className="timeline-panel text-muted">
                                                <span>20 minutes ago</span>
                                                <h6 className="mb-0">New order placed <strong className="text-info">#XF-2356.</strong></h6>
                                                <p className="mb-0">Quisque a consequat ante Sit...</p>
                                            </Link>
                                        </li>
                                        <li>
                                            <div className="timeline-badge danger">
                                            </div>
                                            <Link to={"#"} className="timeline-panel text-muted">
                                                <span>30 minutes ago</span>
                                                <h6 className="mb-0">john just buy your product <strong className="text-warning">Sell $250</strong></h6>
                                            </Link>
                                        </li>
                                        <li>
                                            <div className="timeline-badge success">
                                            </div>
                                            <Link to={"#"} className="timeline-panel text-muted">
                                                <span>15 minutes ago</span>
                                                <h6 className="mb-0">StumbleUpon is acquired by eBay. </h6>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div> */}
                {/* <div className="col-xl-8 col-xxl-8 col-lg-12 col-md-12">
                        <div className="card">
                            <div className="card-header border-0 pb-0">
                                <h4 className="card-title">Recent Payments Queue</h4>
                            </div>
                            <div className="card-body">
                                <PaymentTable />
                            </div>
                        </div>
                    </div> */}
            </div>

            {/* <div className='row'>
                    <div className="col-xl-12 col-xxl-12 col-lg-6 col-sm-6">
                        <Alert variant="warning" dismissible show={state.iconbigwarning} className="left-icon-big">
                            <button className="btn-close" onClick={() => dispatch({ type: 'iconbigwarning' })}><span><i className="mdi mdi-close" /></span></button>
                            <div className='media'>
                                <div variant="" className="alert-left-icon-big">
                                    <span>
                                        <i className="mdi mdi-help-circle-outline"></i>
                                    </span>
                                </div>
                                <div className="media-body">
                                    <h6 className="mt-1 mb-2">Pending Data Classification Tasks!</h6>
                                    <p className="mb-0">You have 4 Data Classification Approvals pending</p>
                                </div>
                            </div>
                        </Alert>
                    </div>
                    
                </div> */}
            {/* <div className='row'>
                    <div className="col-xl-3 col-xxl-3 col-lg-6 col-sm-6">
                        <div className="card bg-success	overflow-hidden">
                            <div className="card-body pb-0 px-4 pt-4">
                                <div className="row">
                                    <div className="col">
                                        <h5 className="text-white mb-1" style={{ fontSize: '2rem' }}>1200</h5>
                                        <span className="text-white" style={{ fontSize: '1.2rem' }}>Total Sensitive Fields In Review</span>
                                    </div>
                                </div>
                            </div>
                            <div className="chart-wrapper" style={{ width: "100%" }}>
                                <Sparklines data={sampleData}>
                                    <SparklinesLine color="#39f4bc"
                                        style={{ stroke: "#20dea6", strokeWidth: 1, fill: "#fff" }}
                                    />
                                </Sparklines>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-xxl-3 col-lg-6 col-sm-6">
                        <div className="card bg-primary overflow-hidden">
                            <div className="card-body pb-0 px-4 pt-4">
                                <div className="row">
                                    <div className="col text-white">
                                        <h5 className="text-white mb-1" style={{ fontSize: '2rem' }}>22,354</h5>
                                        <span style={{ fontSize: '1.2rem' }}>Total Approved Pii Fields</span>
                                    </div>
                                </div>
                            </div>
                            <div className="chart-wrapper px-2">
                                <ChartWidget2 />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-xxl-3 col-lg-6 col-sm-6">
                        <div className="card bg-success	overflow-hidden">
                            <div className="card-body pb-0 px-4 pt-4">
                                <div className="row">
                                    <div className="col">
                                        <h5 className="text-white mb-1" style={{ fontSize: '2rem' }}>22,354</h5>
                                        <span className="text-white" style={{ fontSize: '1.2rem' }}>Total Tagged Fields</span>
                                    </div>
                                </div>
                            </div>
                            <div className="chart-wrapper" style={{ width: "100%" }}>
                                <Sparklines data={sampleData}>
                                    <SparklinesLine color="#39f4bc"
                                        style={{ stroke: "#20dea6", strokeWidth: 1, fill: "#fff" }}
                                    />
                                </Sparklines>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-xxl-3 col-lg-6 col-sm-6">
                        <div className="card bg-primary overflow-hidden">
                            <div className="card-body pb-0 px-4 pt-4">
                                <div className="row">
                                    <div className="col text-white">
                                        <h5 className="text-white mb-1" style={{ fontSize: '2rem' }}>3</h5>
                                        <span style={{ fontSize: '1.2rem' }}>Total Service Now Tickets Intercepted</span>
                                    </div>
                                </div>
                            </div>
                            <div className="chart-wrapper px-2">
                                <ChartWidget2 />
                            </div>
                        </div>
                    </div>
                </div> */}
            <div className='row mt-5'>
                <div className="col-xl-3 col-xxl-3 col-lg-6 col-sm-6">
                    <div className="card 	bg-primary overflow-hidden">
                        <div className="card-body pb-0 px-4 pt-4">
                            <div className="row">
                                <div className="col">
                                    <h5 className="text-white mb-1" style={{ fontSize: '1.5rem' }}>Database Coverage</h5>
                                    <span className="text-white" style={{ fontSize: '1.2rem' }}>90%</span>
                                </div>
                            </div>
                        </div>
                        {/* <div className="chart-wrapper" style={{ width: "100%" }}>
                                <Sparklines data={sampleData}>
                                    <SparklinesLine color="#39f4bc"
                                        style={{ stroke: "#20dea6", strokeWidth: 1, fill: "#fff" }}
                                    />
                                </Sparklines>
                            </div> */}
                    </div>
                </div>
                <div className="col-xl-3 col-xxl-3 col-lg-6 col-sm-6">
                    <div className="card bg-primary  overflow-hidden">
                        <div className="card-body pb-0 px-4 pt-4">
                            <div className="row">
                                <div className="col text-white">
                                    <h5 className="text-white mb-1" style={{ fontSize: '1.5rem' }}>Total ServiceNow Incidents Created</h5>
                                    <span style={{ fontSize: '1.2rem' }}>24</span>
                                </div>
                            </div>
                        </div>
                        <div className="chart-wrapper px-2 pb-4">
                            {/* <ChartWidget2 /> */}
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-xxl-3 col-lg-6 col-sm-6">
                    <div className="card bg-primary 	overflow-hidden">
                        <div className="card-body pb-0 px-4 pt-4">
                            <div className="row">
                                <div className="col">
                                    <h5 className="text-white mb-1" style={{ fontSize: '1.5rem' }}>Total Attributes Covered</h5>
                                    <span className="text-white" style={{ fontSize: '1.2rem' }}>98%</span>
                                </div>
                            </div>
                        </div>
                        <div className="chart-wrapper" style={{ width: "100%" }}>
                            {/* <Sparklines data={sampleData}>
                                    <SparklinesLine color="#39f4bc" 
                                        style={{stroke : "#20dea6", strokeWidth: 1,fill: "#fff"}}
                                    />
                                </Sparklines> */}
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-xxl-3 col-lg-6 col-sm-6">
                    <div className="card  bg-primary overflow-hidden" >
                        <div className="card-body pb-0 px-4 pt-4">
                            <div className="row">
                                <div className="col text-white">
                                    <h5 className="text-white mb-1" style={{ fontSize: '1.5rem' }}>Total Rules Created</h5>
                                    <span style={{ fontSize: '1.2rem' }}>600</span>
                                </div>
                            </div>
                        </div>
                        <div className="chart-wrapper px-2">
                            {/* <ChartWidget2 /> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className="col-xl-6 col-xxl-6 col-lg-6 col-sm-6">
                    <Card>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                textAlign: 'center',
                            }}
                        >
                            <Card.Header >
                                <h1 style={{
                                    fontSize: '30px',
                                    textAlign: 'center',
                                }} className="card-title pt-3">Overall D&A Health</h1>
                            </Card.Header>

                        </div>

                        <Card.Body>
                            <Table responsive hover className="header-border verticle-middle">
                                <thead>
                                    <tr>
                                        <th scope="col" style={{ fontSize: '20px' }}>This Week</th>
                                        <th scope="col" style={{ fontSize: '20px' }}>Last Week</th>
                                        <th scope="col" style={{ fontSize: '20px' }}>Change</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th style={{
                                            fontSize: '30px',
                                        }}>
                                            <Badge style={{
                                                width: '100%',
                                            }} bg="success">90%</Badge>
                                        </th>
                                        <td style={{
                                            fontSize: '30px',
                                        }}>
                                            <Badge style={{
                                                width: '100%',
                                            }} bg="success">92%</Badge>
                                        </td>
                                        <td style={{
                                            fontSize: '30px',
                                        }}>
                                            <Badge style={{
                                                width: '100%',
                                            }} bg="danger">2%</Badge>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                            <Table responsive hover className="header-border verticle-middle mt-3">
                                <thead>
                                    <tr>
                                        <th style={{ fontSize: '20px' }}>Total Rules Ran</th>
                                        <th style={{ fontSize: '20px' }}>Total Rules Passed</th>
                                        <th style={{ fontSize: '20px' }}>Failed Rules</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{
                                            fontSize: '25px',
                                        }}>330</td>
                                        <td style={{
                                            fontSize: '25px',
                                        }}>280</td>
                                        <td style={{
                                            fontSize: '25px',
                                        }}>15%</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Card.Body>

                    </Card>




                </div>



                <div className="col-xl-6 col-xxl-6 col-lg-6 col-sm-6">
                    <Card style={{

                    }}>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                textAlign: 'center',
                            }}
                        >
                            {/* <h4 className="card-title pt-3">
                                    <span style={{ color: 'blue'  }}>{fullBatterySvgIcon}</span>
                                </h4> */}
                            <Card.Header >
                                <h1 style={{
                                    fontSize: '30px', // Increased font size from 25px to 35px
                                    textAlign: 'center',
                                }} className="card-title pt-3">Health Over Time</h1>
                            </Card.Header>

                        </div>

                        <DualArea style={{ width: '100%' }} />

                    </Card>

                </div>

                {/* <div className="col-xl-3 col-xxl-3 col-lg-6 col-sm-6">
                        <div className="card bg-primary overflow-hidden">
                            <div className="card-body pb-0 px-4 pt-4">
                                <div className="row">
                                    <div className="col text-white">
                                        <h5 className="text-white mb-1">22,354</h5>
                                        <span>Total Approved Pii Fields</span>
                                    </div>
                                </div>
                            </div>
                            <div className="chart-wrapper px-2">									
                                <ChartWidget2 />
                            </div>
                        </div>
                    </div> */}
                {/* <div className="col-xl-3 col-xxl-3 col-lg-6 col-sm-6">
                        <div className="card bg-success	overflow-hidden">
                            <div className="card-body pb-0 px-4 pt-4">
                                <div className="row">
                                    <div className="col">
                                        <h5 className="text-white mb-1">22,354</h5>
                                        <span className="text-white">Total Tagged Fields</span>
                                    </div>
                                </div>
                            </div>
                            <div className="chart-wrapper" style={{width:"100%"}}>
                                <Sparklines data={sampleData}>
                                    <SparklinesLine color="#39f4bc" 
                                        style={{stroke : "#20dea6", strokeWidth: 1,fill: "#fff"}}
                                    />
                                </Sparklines>
                            </div>
                        </div>
                    </div> */}
                {/* <div className="col-xl-3 col-xxl-3 col-lg-6 col-sm-6">
                        <div className="card bg-primary overflow-hidden">
                            <div className="card-body pb-0 px-4 pt-4">
                                <div className="row">
                                    <div className="col text-white">
                                        <h5 className="text-white mb-1">3</h5>
                                        <span>Total Service Now Tickets Intercepted</span>
                                    </div>
                                </div>
                            </div>
                            <div className="chart-wrapper px-2">									
                                <ChartWidget2 />
                            </div>
                        </div>
                    </div> */}
            </div>

            <div className='row mt-5'>
                {bgCarddBlog.map((item, index) => (
                    <Col xl={3} xxl={6} lg={6} sm={6} key={index}>
                        <div className={`widget-stat card bg-${item.color}`}>
                            <div className="card-body p-4">
                                <BgCard
                                    title={
                                        <span style={{ fontSize: '1.2rem' }}>
                                            {item.title + " " + item.percent}
                                        </span>
                                    }
                                    percent={
                                        <span style={{ fontSize: '1.1rem' }}>
                                            {item.percent}
                                        </span>
                                    }
                                    color={item.color}
                                    icon={
                                        <span style={{ fontSize: '1.3rem' }}>
                                            {item.icon}
                                        </span>
                                    }
                                />
                            </div>
                        </div>
                    </Col>
                ))}
            </div>
            <div className='row'>
                <div className="col-xl-8 col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title" style={{ fontSize: '1.5rem' }}>Dimensions</h4>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-xl-4 col-xxl-6 col-6">
                                    <div className="form-check custom-checkbox mb-3">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customCheckBox1"
                                            required
                                            style={{ transform: 'scale(1.2)' }}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="customCheckBox1"
                                            style={{ fontSize: '1.2rem' }}
                                        >
                                            Conformity
                                        </label>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-xxl-6 col-6">
                                    <div className="form-check custom-checkbox mb-3">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customCheckBox2"
                                            required
                                            style={{ transform: 'scale(1.2)' }}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="customCheckBox2"
                                            style={{ fontSize: '1.2rem' }}
                                        >
                                            Uniqueness
                                        </label>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-xxl-6 col-6">
                                    <div className="form-check custom-checkbox mb-3">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customCheckBox3"
                                            required
                                            style={{ transform: 'scale(1.2)' }}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="customCheckBox3"
                                            style={{ fontSize: '1.2rem' }}
                                        >
                                            Overall
                                        </label>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-xxl-6 col-6">
                                    <div className="form-check custom-checkbox mb-3">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customCheckBox4"
                                            required
                                            style={{ transform: 'scale(1.2)' }}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="customCheckBox4"
                                            style={{ fontSize: '1.2rem' }}
                                        >
                                            Accuracy
                                        </label>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-xxl-6 col-6">
                                    <div className="form-check custom-checkbox mb-3">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customCheckBox5"
                                            required
                                            style={{ transform: 'scale(1.2)' }}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="customCheckBox5"
                                            style={{ fontSize: '1.2rem' }}
                                        >
                                            Timeliness
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="col-xl-4 col-lg-6">
                    <Card>
                        <Card.Header className=" d-block">
                            <Card.Title style={{ fontSize: '1.5rem' }}>Object Breakdown</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <h6 style={{ fontSize: '1.2rem' }}>
                                Table 1
                                <span className="pull-end">85%</span>
                            </h6>
                            <ProgressBar now={85} variant="success" style={{ height: '1.5rem' }} />

                            <h6 className="mt-4" style={{ fontSize: '1.2rem' }}>
                                Table 2
                                <span className="pull-end">90%</span>
                            </h6>
                            <ProgressBar now="90" variant="success" style={{ height: '1.5rem' }} />
                            <h6 className="mt-4" style={{ fontSize: '1.2rem' }}>
                                Table 3
                                <span className="pull-end">65%</span>
                            </h6>
                            <ProgressBar now={65} variant="warning" style={{ height: '1.5rem' }} />
                        </Card.Body>
                    </Card>
                </div>
            </div>

            <div className='row'>
                <Col xl={12} lg={12} sm={12} >
                    <div className="row">
                        <div className="col-xl-3 col-xxl-6 col-lg-6 col-sm-6">
                            <div className="widget-stat card bg-primary">
                                <TtitleCode title="Accuracy" number="90%" design="pb-0" />
                                <div className="card-body text-center">
                                    <div className="ico-sparkline">
                                        <TotalStudent />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-xxl-6 col-lg-6 col-sm-6">
                            <div className="widget-stat card bg-primary">
                                <TtitleCode title="Comformity" number="90%" design="pb-0" />
                                <div className="card-body text-center">
                                    <div className="ico-sparkline">
                                        <TotalStudent />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-xxl-6 col-lg-6 col-sm-6">
                            <div className="widget-stat card bg-primary">
                                <TtitleCode title="Uniqueness" number="90%" design="pb-0" />
                                <div className="card-body text-center">
                                    <div className="ico-sparkline">
                                        <TotalStudent />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-xxl-6 col-lg-6 col-sm-6">
                            <div className="widget-stat card bg-primary">
                                <TtitleCode title="Structure" number="90%" design="pb-0" />
                                <div className="card-body text-center">
                                    <div className="ico-sparkline">
                                        <TotalStudent />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-xl-3 col-xxl-6 col-lg-6 col-sm-6">
                                                <div className="widget-stat card bg-warning overflow-hidden">
                                                    <TtitleCode title="New Students" number="357" />
                                                    <div className="card-body text-center p-0">
                                                        <div className="ico-sparkline">
                                                            <NewStudent />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> */}
                        {/* <div className="col-xl-3 col-xxl-6 col-lg-6 col-sm-6">
                                                <div className="widget-stat card bg-secondary overflow-hidden">
                                                    <TtitleCode title="Total Course" number="547" design="pb-3 pb-0" />
                                                    <div className="card-body p-0">
                                                        <div className="px-4">
                                                            <TotalCourse />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> */}
                        {/* <div className="col-xl-3 col-xxl-6 col-lg-6 col-sm-6">
                                                <div className="widget-stat card bg-danger overflow-hidden">
                                                    <TtitleCode title="Fees Collection" number="3280$" design="pb-3 pb-0" />
                                                    <div className="card-body p-0">
                                                        <FeeCollection />
                                                    </div>
                                                </div>
                                            </div> */}
                    </div>
                </Col>


            </div>
            <div className='row'>

                <div className="col-xl-6 col-xxl-6 col-lg-6 col-sm-6">

                    <Card style={{

                    }}>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                textAlign: 'center',
                            }}
                        >
                            {/* <h4 className="card-title pt-3">
                                    <span style={{ color: 'blue'  }}>{fullBatterySvgIcon}</span>
                                </h4> */}
                            <Card.Header >
                                <h1 style={{
                                    fontSize: '30px', // Increased font size from 25px to 35px
                                    textAlign: 'center',
                                }} className="card-title pt-3">Reccurence</h1>
                            </Card.Header>

                        </div>

                        <ApexLine4 style={{ width: '100%' }} />

                    </Card>

                </div>
                <div className="col-xl-6 col-xxl-6 col-lg-6 col-sm-6">
                    <Card>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                textAlign: 'center',
                            }}
                        >
                            <Card.Header>

                                <Card.Title style={{ fontSize: '24px', textAlign: 'center' }}>Coverage Percent</Card.Title>
                            </Card.Header>
                        </div>

                        <Card.Body>
                            <Table responsive bordered style={{ fontSize: '18px' }}>
                                <thead>
                                    <tr>
                                        <th>Data Source</th>
                                        <th>Uniqueness %</th>
                                        <th>Completeness %</th>
                                        <th>Validity %</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>SFDC APAC
                                        </td>
                                        <td>
                                            <Badge bg="primary" style={{ fontSize: '16px' }}>82</Badge>
                                        </td>
                                        <td>81</td>
                                        <td className="color-primary">74</td>
                                    </tr>
                                    <tr>
                                        <td>SFDC EMEA
                                        </td>
                                        <td>
                                            <span className="badge badge-success" style={{ fontSize: '16px' }}>80</span>
                                        </td>
                                        <td>78</td>
                                        <td className="color-success">80</td>
                                    </tr>
                                    <tr>
                                        <td>Dynamics</td>
                                        <td>
                                            <Badge bg="danger" style={{ fontSize: '16px' }}>85</Badge>
                                        </td>
                                        <td>80</td>
                                        <td className="color-danger">84</td>
                                    </tr>
                                    <tr>
                                        <td>Data Mart
                                        </td>
                                        <td>
                                            <Badge bg="warning" style={{ fontSize: '16px' }}>81</Badge>
                                        </td>
                                        <td>80</td>
                                        <td className="color-warning">77</td>
                                    </tr>
                                    <tr>
                                        <td>Files</td>
                                        <td>
                                            <Badge bg="info" style={{ fontSize: '16px' }}>64</Badge>
                                        </td>
                                        <td>65</td>
                                        <td className="color-info">60</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>


                </div>



            </div>
            <div className='row'>


                <div className="col-xl-6 col-lg-6">
                    <Card>
                        <Card.Header className=" d-block">
                            <Card.Title style={{ fontSize: '1.5rem' }}>Top In Healthy</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <h6 style={{ fontSize: '1.2rem' }}>
                                Object 1
                                <span className="pull-end">85%</span>
                            </h6>
                            <ProgressBar now={85} variant="success" style={{ height: '1.5rem' }} />

                            <h6 className="mt-4" style={{ fontSize: '1.2rem' }}>
                                Object 2
                                <span className="pull-end">90%</span>
                            </h6>
                            <ProgressBar now="90" variant="success" style={{ height: '1.5rem' }} />
                            <h6 className="mt-4" style={{ fontSize: '1.2rem' }}>
                                Object 3
                                <span className="pull-end">65%</span>
                            </h6>
                            <ProgressBar now={65} variant="warning" style={{ height: '1.5rem' }} />
                        </Card.Body>
                    </Card>
                </div>
                <div className="col-xl-6 col-lg-6">
                    <Card>
                        <Card.Header className=" d-block">
                            <Card.Title style={{ fontSize: '1.5rem' }}>Top In Unhealthy</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <h6 style={{ fontSize: '1.2rem' }}>
                                Object 1
                                <span className="pull-end">85%</span>
                            </h6>
                            <ProgressBar now={85} variant="success" style={{ height: '1.5rem' }} />

                            <h6 className="mt-4" style={{ fontSize: '1.2rem' }}>
                                Object 2
                                <span className="pull-end">90%</span>
                            </h6>
                            <ProgressBar now="90" variant="success" style={{ height: '1.5rem' }} />
                            <h6 className="mt-4" style={{ fontSize: '1.2rem' }}>
                                Object 3
                                <span className="pull-end">65%</span>
                            </h6>
                            <ProgressBar now={65} variant="warning" style={{ height: '1.5rem' }} />
                        </Card.Body>
                    </Card>
                </div>
            </div>


            {/* <div className="col-xl-3 col-xxl-4 col-lg-12 col-md-12">
                <div className="card bg-primary text-white">
                    <div className="card-header pb-0 border-0">
                        <h4 className="card-title text-white">TOP PRODUCTS</h4>
                    </div>
                    <TopProducts />
                </div>
            </div> */}
            {/* <div className="col-xl-3 col-xxl-4 col-lg-6 col-md-6">
                <div className="card bg-info activity_overview">
                    <div className="card-header  border-0 pb-3 ">
                        <h4 className="card-title text-white">Data Classification Activity</h4>
                    </div>
                    <ActivityTab />
                </div>
            </div> */}

            {/* <div className="col-xl-4 col-xxl-12 col-lg-12 col-md-12">
                <UserActivity />
            </div> */}
            {/* <div className='row'>
                <div className="col-xl-3 col-xxl-12 col-lg-12 col-md-12">
                    <div className="card active_users">
                        <div className="card-header bg-success border-0 pb-0">
                            <h4 className="card-title text-white">User Roles</h4>
                        </div>
                        <div className="bg-success">
                            <ActiveUserCanvas />
                        </div>
                        <div className="card-body pt-0">
                            <div className="list-group-flush mt-4">
                                <div className="list-group-item bg-transparent d-flex justify-content-between px-0 py-1 font-weight-semi-bold border-0 border-bottom"
                                    style={{ borderColor: "rgba(255, 255, 255, 0.15)" }}
                                >
                                    <p className="mb-0">Top Active Roles</p>
                                    <p className="mb-0">User Count</p>
                                </div>
                                <div className="list-group-item bg-transparent d-flex justify-content-between px-0 py-1 border-0 border-bottom"
                                    style={{ borderColor: "rgba(255, 255, 255, 0.05)" }}
                                >
                                    <p className="mb-0">ACCOUNTADMIN</p>
                                    <p className="mb-0">3</p>
                                </div>
                                <div className="list-group-item bg-transparent d-flex justify-content-between px-0 py-1 border-0 border-bottom"
                                    style={{ borderColor: "rgba(255, 255, 255, 0.05)" }}
                                >
                                    <p className="mb-0">COMPLIANCE_ADMIN</p>
                                    <p className="mb-0">1</p>
                                </div>
                                <div className="list-group-item bg-transparent d-flex justify-content-between px-0 py-1 border-0 border-bottom"
                                    style={{ borderColor: "rgba(255, 255, 255, 0.05)" }}
                                >
                                    <p className="mb-0">COMPLIANCE_READER</p>
                                    <p className="mb-0">5</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div> */}


        </div>
    );
}

export { AllSection };
export default Home;